'use strict';

window.EFC = window.EFC || {};

window.EFC.Forms = function($) {
  function init() {
    $('.gfield input, .gfield textarea').on('change', setNotEmptyClass)
      .each(setNotEmptyClass);
  }
  
  function setNotEmptyClass() {
    const hasValue = !!this.value;
    $(this).closest('.gfield').toggleClass('gfield--notempty', hasValue);
  }
  
  function downloadForm(selector) {
    var $form = $(selector);
    
    var oldTarget = $form.attr('target');
    $form.attr('target', '_blank');
    
    var oldAction = $form.attr('action');
    $form.attr('action', window.location.href + '?download');
    
    var $removedFields = $form.find('input[name=gform_submit],input[name=is_submit_1]');
    $removedFields.prop('disabled', true);  
    
    
    $form.find('input[name=gform_target_page_number_1]').val('6');
    $form.find('input[name=gform_source_page_number_1]').val('5');
    
    $form.submit();
    
    $form.attr('target', oldTarget);
    $form.attr('action', oldAction);
    $removedFields.prop('disabled', false);
  }
  
  $(init);
  
  return {
    downloadForm: downloadForm
  }
}(jQuery);